(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["catalog-product-grid"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initCatalogAvailabilitySort = () => {
    const grids = document.querySelectorAll('[data-section-id][data-total-pages][data-catalog-availability-sort-ready="false"]');

    grids.forEach(async (grid) => {
      grid.dataset.catalogAvailabilitySortReady = 'true';

      const totalPages = Number(grid.dataset.totalPages || 1);
      const totalProducts = Number(grid.dataset.totalProducts || 0);
      const productsPerPage = Number(grid.dataset.productsPerPage || 16);
      const currentPage = Number(grid.dataset.currentPage || 1);

      if (totalPages <= 1 || totalProducts <= productsPerPage) {
        const items = Array.from(grid.querySelectorAll('[data-catalog-product]'));
        items.sort((a, b) => Number(b.dataset.available === 'true') - Number(a.dataset.available === 'true'));
        items.forEach((item) => grid.appendChild(item));
        return;
      }

      const sectionId = grid.dataset.sectionId;
      const baseUrl = new URL(window.location.href);
      const currentItems = Array.from(grid.querySelectorAll('[data-catalog-product]'));
      const pages = Array.from({ length: totalPages }, (_, index) => index + 1);

      const pageItems = new Map();
      pageItems.set(currentPage, currentItems);

      const fetchPage = async (page) => {
        if (page === currentPage) return currentItems;

        const url = new URL(baseUrl);
        url.searchParams.set('page', String(page));
        url.searchParams.set('sections', sectionId);

        const response = await fetch(url.toString(), { credentials: 'same-origin' });
        if (!response.ok) throw new Error('Catalog section request failed');

        const data = await response.json();
        const html = data[sectionId];
        if (!html) throw new Error('Catalog section response was empty');

        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const fetchedGrid = doc.querySelector('[data-catalog-product]')?.closest('ul[data-section-id]');

        if (!fetchedGrid) throw new Error('Catalog product grid was not found');

        return Array.from(fetchedGrid.querySelectorAll('[data-catalog-product]'));
      };

      try {
        const batchSize = 4;

        for (let start = 0; start < pages.length; start += batchSize) {
          const batch = pages.slice(start, start + batchSize).filter((page) => !pageItems.has(page));
          const results = await Promise.all(batch.map(async (page) => [page, await fetchPage(page)]));
          results.forEach(([page, items]) => pageItems.set(page, items));
        }

        const allItems = pages.flatMap((page) => pageItems.get(page) || []);

        if (allItems.length !== totalProducts) return;

        allItems.sort((a, b) => {
          const aAvailable = a.dataset.available === 'true';
          const bAvailable = b.dataset.available === 'true';
          return Number(bAvailable) - Number(aAvailable);
        });

        // Keep two products from the "dolls" collection on each of the first five pages.
        const dollItems = allItems.filter((item) => item.dataset.isDoll === 'true');
        const nonDollItems = allItems.filter((item) => item.dataset.isDoll !== 'true');

        const firstFiveDolls = dollItems.slice(0, 10);
        const remainingDolls = dollItems.slice(10);

        const arrangedItems = [];
        let nonDollIndex = 0;

        for (let page = 1; page <= 5 && page <= totalPages; page++) {
          const dollsForPage = firstFiveDolls.slice((page - 1) * 2, page * 2);
          const nonDollsForPage = nonDollItems.slice(nonDollIndex, nonDollIndex + productsPerPage - dollsForPage.length);
          nonDollIndex += nonDollsForPage.length;

          // Distribute the two dolls across the page instead of placing them together.
          if (dollsForPage.length === 2) {
            const firstPosition = Math.floor(productsPerPage / 3);
            const secondPosition = Math.floor((productsPerPage * 2) / 3);
            let dollIndex = 0;

            for (let position = 0; position < productsPerPage; position++) {
              if (position === firstPosition || position === secondPosition) {
                arrangedItems.push(dollsForPage[dollIndex++]);
              } else {
                arrangedItems.push(nonDollsForPage.shift());
              }
            }
          } else {
            arrangedItems.push(...nonDollsForPage);
            arrangedItems.push(...dollsForPage);
          }
        }

        arrangedItems.push(...nonDollItems.slice(nonDollIndex));
        arrangedItems.push(...remainingDolls);

        const startIndex = (currentPage - 1) * productsPerPage;
        const visibleItems = arrangedItems.slice(startIndex, startIndex + productsPerPage);

        grid.replaceChildren(...visibleItems);
      } catch (error) {
        console.warn('Catalog availability sorting was not applied.', error);
      }
    });
  };

  initCatalogAvailabilitySort();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('.section-header');

    if (!this.header) return;

    this.headerIsAlwaysSticky =
      this.getAttribute('data-sticky-type') === 'always' ||
      this.getAttribute('data-sticky-type') === 'reduce-logo-size';

    this.headerBounds = {};
    this.currentScrollTop = 0;
    this.preventReveal = false;

    this.setHeaderHeight();

    this.mediaQuery = window.matchMedia('(max-width: 990px)');
    this.setHeaderHeightHandler = this.setHeaderHeight.bind(this);
    this.mediaQuery.addEventListener('change', this.setHeaderHeightHandler);

    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    }

    this.predictiveSearch = this.querySelector('predictive-search');

    this.onScrollHandler = this.onScroll.bind(this);

    this.hideHeaderOnScrollUp = () => {
      this.preventReveal = true;
    };

    this.addEventListener(
      'preventHeaderReveal',
      this.hideHeaderOnScrollUp
    );

    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
  }

  disconnectedCallback() {
    this.removeEventListener(
      'preventHeaderReveal',
      this.hideHeaderOnScrollUp
    );

    window.removeEventListener('scroll', this.onScrollHandler);

    if (this.mediaQuery && this.setHeaderHeightHandler) {
      this.mediaQuery.removeEventListener(
        'change',
        this.setHeaderHeightHandler
      );
    }
  }

  setHeaderHeight() {
    if (!this.header) return;

    document.documentElement.style.setProperty(
      '--header-height',
      `${this.header.offsetHeight}px`
    );
  }

  createObserver() {
    const observer = new IntersectionObserver((entries) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop =
      window.pageYOffset || document.documentElement.scrollTop;

    if (this.predictiveSearch?.isOpen) return;

    const headerBottom = this.headerBounds.bottom || 0;
    const headerTop = this.headerBounds.top || 0;

    // Scrolling down past the header
    if (
      scrollTop > this.currentScrollTop &&
      scrollTop > headerBottom
    ) {
      this.header.classList.add('scrolled-past-header');

      if (!this.preventHide) {
        requestAnimationFrame(() => this.hide());
      }
    }

    // Scrolling back up
    else if (
      scrollTop < this.currentScrollTop &&
      scrollTop > headerBottom
    ) {
      this.header.classList.add('scrolled-past-header');

      if (!this.preventReveal) {
        requestAnimationFrame(() => this.reveal());
      } else {
        clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        requestAnimationFrame(() => this.hide());
      }
    }

    // Back at the top of the page
    else if (scrollTop <= headerTop) {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(() => this.reset());
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (this.headerIsAlwaysSticky) return;

    this.header.classList.add(
      'shopify-section-header-hidden',
      'shopify-section-header-sticky'
    );

    this.closeMenuDisclosure();
    this.closeSearchModal();
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;

    this.header.classList.add(
      'shopify-section-header-sticky',
      'animate'
    );

    this.header.classList.remove(
      'shopify-section-header-hidden'
    );
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;

    this.header.classList.remove(
      'shopify-section-header-hidden',
      'shopify-section-header-sticky',
      'animate'
    );
  }

  closeMenuDisclosure() {
    const disclosures =
      this.header.querySelectorAll('header-menu');

    disclosures.forEach((disclosure) => {
      if (typeof disclosure.close === 'function') {
        disclosure.close();
      }
    });
  }

  closeSearchModal() {
    const searchModal =
      this.header.querySelector('details-modal');

    if (searchModal && typeof searchModal.close === 'function') {
      searchModal.close(false);
    }
  }
}

customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
